<navaar-container-scroll
  [showHeader]="true"
  [title]="'راهنما و پشتیبانی'"
  [show]="true"
  [isPlayAnimation]="false"
  [showIcon]="true"
  [isFixedContainer]="true"
  [back-url]="['/profile']"
>
  <section class="feedback-section">
    <div class="home-page-wrapper">
      <h2 class="title-home-page">سوالات متداول</h2>
      <div class="question-wrapper">
        <ng-template ngFor [ngForOf]="questionItems" let-item let-i="index">
          <div class="question-item" [class.active]="selectedItemQuestion === i">
            <p class="accordion"
               (click)="selectedItemQuestion === i ? selectedItemQuestion = null : selectedItemQuestion = i">
              <b [textContent]="item.question"></b>
              <img src="assets/icon-new/arrow.svg" style="width: 8px">
            </p>
            <div class="panel">
              <span [innerHTML]="item.answer"></span>
            </div>
          </div>
        </ng-template>
      </div>
      <br><br><br>
      <h2 class="title-home-page">مشکل‌تان در لیست بالا نبود؟</h2>
      <div class="other-question-wrapper">
        <ng-template [ngIf]="(deviceService.getFeaturesetVersion() >= 3)" [ngIfElse]="unsupported_call_temp">
          <ng-template [ngIf]="isPhoneDevice" [ngIfElse]="phone_web_temp">
            <p (click)="callToPhone('02191004741')">
              <img src="assets/icon-new/icon-phone.svg" class="icon-item">
              <b>
                <span style="margin: 0">تماس با پشتیبانی</span>
              </b>
              <i></i>
              <img src="assets/icon-new/arrow.svg" class="icon-item-arrow" style="width: 8px">
            </p>
          </ng-template>
          <ng-template #phone_web_temp>
            <p>
              <img src="assets/icon-new/icon-phone.svg" class="icon-item">
              <b>
                <a href="tel:02191004741">تماس با پشتیبانی</a>
              </b>
              <i></i>
              <img src="assets/icon-new/arrow.svg" class="icon-item-arrow" style="width: 8px">
            </p>
          </ng-template>

        </ng-template>
        <ng-template #unsupported_call_temp>
          <p (click)="openShowPhoneNumberSupportDialog($event, '021 91004741')">
            <img src="assets/icon-new/icon-phone.svg" class="icon-item">
            <b>
              <span style="margin: 0">تماس با پشتیبانی</span>
            </b>
            <i></i>
            <img src="assets/icon-new/arrow.svg" class="icon-item-arrow" style="width: 8px">
          </p>
        </ng-template>
        <p [routerLink]="['goftino']" (click)="routeToGoftino()">
          <img src="assets/icon-new/icon-email.svg" class="icon-item">
          <b>ارسال پیام به پشتیبانی</b>
          <i></i>
          <span #unread_count_message_goftino id="unread_count_message_goftino">0</span>
          <img src="assets/icon-new/arrow.svg" class="icon-item-arrow" style="width: 8px">
        </p>
        <!--        <p>-->
        <!--          <img src="assets/icon-new/icon-email.svg" class="icon-item">-->
        <!--          <b [routerLink]="['send-feedback']">ارسال تیکت پشتیبانی</b>-->
        <!--          <img src="assets/icon-new/arrow.svg" class="icon-item-arrow">-->
        <!--        </p>-->
      </div>
    </div>
  </section>
</navaar-container-scroll>
